import { useContext, createContext } from "react";
/*istanbul ignore next */
export const VendorInit = {
  isEditMode: true,
  setEditMode(val) {
    this.isEditMode = val;
  },
};

export const VendorContext = createContext(VendorInit);

export const useVendorContext = () => useContext(VendorContext);
